
<div class="modal" id='popupID-dados-recebedor' tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  style="z-index: 9999;" aria-hidden="true" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-w">    
      
      <div class="modal-header justify-content-between">
        <h5 class="modal-title"> Dados do recebedor </h5>
        <img id="btnCloseModalDadoRecebedor" data-bs-dismiss="modal" class='bt-fechar me-3' src="assets/img/icons/close-white.svg"  >
      </div>

      <div class="loading-comprovante" *ngIf="boxInfoRouterService.loadingComprovante"> Carregando comprovante...</div>


      <div class="modal-body"> 
        <div class='col'>       
          <app-dual-info-component 
            tituloPrincipal="Nome" 
            [infoPrincipal]="boxInfoRouterService.dadosComprovante != null? boxInfoRouterService.dadosComprovante.NomeRecebedor: ''" 
            tituloSecundario="Documento" 
            [infoSecundario]="boxInfoRouterService.dadosComprovante != null? boxInfoRouterService.dadosComprovante.DocumentoRecebedor: ''" 
            [centralizarTexto]="false"
          >
          </app-dual-info-component>

          <div style="height: 400px;" *ngIf="boxInfoRouterService.dadosComprovante != null;else semComprovante">
            <div class="d-flex justify-content-center m-1" > 
              <img  src="data:image/jpeg;base64,{{ boxInfoRouterService.dadosComprovante.Arquivo }}" class="comprovante"
                (load)="onImageLoad($event)">
            </div>
            <h5 class="modal-dthora"> {{boxInfoRouterService.dadosComprovante.dataFinalEntrega | date:'dd/MM/yyyy HH:mm'}} 
               <img src="assets/img/icons/icon-info-circle.svg" *ngIf="boxInfoRouterService.avisoAlteracao"
                style="font-size:15px; padding: 5px; " 
                  placement="right" 
                  tooltipClass="custom-tooltip" 
                  [ngbTooltip]="boxInfoRouterService.avisoAlteracao" 
                  class="fa fa-warning ms-2"
                  tooltipClass="classTooltip">
            </h5>
          </div>
          <ng-template #semComprovante>
            <div class="sem-comprovante"></div>
          </ng-template>
          <div class="d-flex justify-content-between align-items-baseline mt-5">

            <input type="file"  id="inputFileComprovante" hidden="true" accept=".png,.jpeg,.jpg" (change)="selecionaArquivos($event)" >
            <div  (click)="anexarArquivos()" class="ms-4 ">
              <app-texto-link titulo="Atualizar comprovante"  icone='icon-lapis-green' ></app-texto-link>
            </div>
            <app-botao-primario  style="margin-right: 14px;"        
              titulo="Download" 
              imagemBtn="assets/img/icons/download_comprovante.svg"
              [modoDark]="true"
              (onPress)="downloadPDFRecibo()"

            ></app-botao-primario>
          </div>
          
        </div>
      </div>

   
    </div>
  </div>
</div>
